import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

export const subscriptionsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "0 1rem",
  gap: "0.5rem",
  alignItems: "flex-start",
};

export const subscriptionTitleCss: CSSObject = {
  color: constants.colors.ui.neutral[700],
  lineHeight: "1.5rem",
  fontWeight: 700,
  fontSize: "1rem",
  margin: 0,
};

export const subscriptionUnorderedListCss: CSSObject = {
  padding: 0,
  margin: 0,
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
  listStyleType: "disc !important",
  fontFamily: "Circular, Helvetica, Arial, sans-serif",

  li: {
    color: constants.colors.ui.neutral[700],
    lineHeight: "1.5rem",
    marginLeft: "1.5rem",
    textAlign: "left",
  },
};

export const daysLeftCss = {
  color: constants.colors.ui.red[600],
  marginInlineStart: 5,
  ...typographyStyles.textSObj,
};

export const expirationDateCss: CSSObject = {
  fontWeight: 400,
  margin: 0,
  fontSize: "14px",
  color: constants.colors.ui.neutral[700],

  strong: {
    fontWeight: 700,
  },
};
